import { Trans, useTranslation } from 'react-i18next';

import { boldElement } from 'components/ConfirmPopup';

interface DeleteWorkspaceConfirmationMessageProps {
  workspaceName: string;
  subWorkspaceCount: number;
}

const DeleteWorkspaceConfirmationMessage = ({
  workspaceName,
  subWorkspaceCount,
}: DeleteWorkspaceConfirmationMessageProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2 text-center">
      <Trans
        i18nKey="workspaces.delete_workspace_question"
        components={{ bold: boldElement }}
        values={{ workspaceName }}
      />
      {subWorkspaceCount > 0 && (
        <p className="text-size-sm text-gray-80">
          {t('workspaces.delete_workspace_subworkspace_cascade', { count: subWorkspaceCount })}
        </p>
      )}
    </div>
  );
};

export default DeleteWorkspaceConfirmationMessage;
